import { Chip, Typography } from "@mui/material"
import type { FC } from "react"

import { useGetTransferProductInventory } from "../../hooks/useGetTransferProductInventory"

import type { Product, WarehouseArea } from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"
import { formatWarehouseLabel } from "@/utils/warehouse"

interface TransferInventoryHeaderProps {
  product: Product
  warehouseArea: WarehouseArea
}

export const TransferInventoryHeader: FC<TransferInventoryHeaderProps> = ({ product, warehouseArea }) => {
  const { inventory } = useGetTransferProductInventory({
    productId: product.productId,
    warehouseAreaId: warehouseArea.warehouseAreaId,
  })

  const warehouseInventory = inventory?.warehouses.find(
    (warehouse) => warehouse.warehouseId === warehouseArea.warehouseAreaId
  )
  const warehouseLabel = warehouseInventory
    ? `${formatWarehouseLabel(warehouseArea)} (${warehouseInventory.numPallets} pallets / ${formatNumber(warehouseInventory.qtyOnHand)} on hand)`
    : formatWarehouseLabel(warehouseArea)

  return (
    <div className='flex items-center gap-x-6 border-b border-gray-400 bg-gray-100 px-10 py-3'>
      <div className='flex items-center gap-x-2'>
        <Typography variant='body2' className='shrink-0 text-gray-700'>
          Product:
        </Typography>
        <Chip
          label={product.companyProductDescription}
          size='small'
          className='rounded-sm bg-gray-300'
          data-testid={"transfer.inventory-header.product"}
        />
      </div>
      <div className='flex items-center gap-x-2'>
        <Typography variant='body2' className='shrink-0 text-gray-700'>
          Warehouse:
        </Typography>
        <Chip
          label={warehouseLabel}
          size='small'
          className='rounded-sm bg-gray-300'
          data-testid={"transfer.inventory-header.warehouse"}
        />
      </div>
    </div>
  )
}
